<template>
  <a
    href="#main-content"
    class="typo-sans-1 mx-auto text-center w-fit uppercase bottom-8 right-0 fixed z-99 -left-9999 focus:left-0"
  >
    {{ $t('skip_to_content') }}
  </a>
</template>
